import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { UntilDestroy, untilDestroyed } from '@shared';
import { BreadcrumbService } from '@shared/services/breadcrumb/breadcrumb.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { distinctUntilChanged } from 'rxjs';
import { CourseDetailsModelV2, selectCourse, selectCourseV2 } from 'thkee-common';
import { HeaderActions } from '../components/course-header/course-header.component';
import { CourseScheduleComponent } from '../course-schedule/course-schedule.component';
import { CourseCurriculumComponent } from '../curriculum/curriculum.component';
import { CourseDetailsComponent } from '../detail/detail.component';
import { CourseIntendedComponent } from '../intended/intended.component';
import { CoursePricingComponent } from '../pricing/pricing.component';
@UntilDestroy()
@Component({
  selector: 'app-course-revision',
  templateUrl: './course-revision.component.html',
  styleUrls: ['./course-revision.component.scss'],
  imports: [
    AsyncPipe,
    CourseIntendedComponent,
    CourseDetailsComponent,
    CourseCurriculumComponent,
    CoursePricingComponent,
    NgTemplateOutlet,
    AngularSvgIconModule,
    CourseScheduleComponent,
  ],
})
export class CourseRevisionComponent implements OnInit {
  private store = inject(Store);
  private breadcrumbService = inject(BreadcrumbService);

  course$ = this.store.select(selectCourseV2);

  //steper
  currentStep = 0;
  steps: Array<{ title: string }> = [];

  ngOnInit(): void {
    this.store
      .select(selectCourse)
      .pipe(distinctUntilChanged(), untilDestroyed(this))
      .subscribe((course) => {
        this.breadcrumbGenerator(course.title);
      });

    this.store
      .select(selectCourseV2)
      .pipe(distinctUntilChanged(), untilDestroyed(this))
      .subscribe((course) => {
        this.stepperGenerator(course);
      });
  }

  stepperGenerator(course: CourseDetailsModelV2) {
    if (course.course_mode === 'video_based') {
      this.steps = [{ title: 'Intended Learner' }, { title: 'Detail' }, { title: 'Curriculum' }, { title: 'Pricing' }];
    } else {
      this.steps = [{ title: 'Intended Learner' }, { title: 'Detail' }, { title: 'Schedule' }, { title: 'Pricing' }];
    }
  }

  breadcrumb: { label: string; url: string }[] = [];
  breadcrumbGenerator(courseTitle: string) {
    this.breadcrumb = [
      {
        label: 'Courses',
        url: '/courses',
      },
      {
        label: 'To Review',
        url: '/courses/review',
      },
      {
        label: `${courseTitle}`,
        url: '',
      },
    ];
    this.breadcrumbService.setBreadcrumbs(this.breadcrumb);
  }

  // Stepper
  setStep(step: number) {
    this.currentStep = step;
  }

  nextStep() {
    if (this.currentStep < this.steps.length) {
      this.currentStep++;
    }
  }

  prevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  submit() {
    alert('Form submitted');
  }

  // Header action
  @ViewChild('intend') private intend!: CourseIntendedComponent;
  actionEvent(event: HeaderActions) {
    this.intend.actionEvent(event);
  }
}
